/* eslint-disable max-len */
import PropTypes from 'prop-types';

import {
    UserIcon as SourceUserIcon
} from 'SourceComponent/UserIcon/UserIcon.component';

import './UserIcon.override.style';

/** @namespace PeggysagePwa/Component/UserIcon/Component */
export class UserIconComponent extends SourceUserIcon {
    static propTypes = {
        ...SourceUserIcon.propTypes,
        isPro: PropTypes.bool,
        isStudent: PropTypes.bool
    };

    static defaultProps = {
        ...SourceUserIcon.defaultProps,
        isPro: false,
        isStudent: false
    };

    renderProIcon() {
        const { isActive } = this.props;

        return (
            <svg
              block="UserIcon"
              mods={ { isActive, isPro: true } }
              width="26"
              height="28"
              viewBox="0 0 26 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path d="M13,10.7L13,10.7c2.9,0,5.3-2.4,5.4-5.4C18.4,2.4,16,0,13.1,0l0,0c-2.9,0-5.3,2.4-5.3,5.3c0,1.4,0.6,2.8,1.6,3.8
                        C10.2,10.1,11.5,10.7,13,10.7z M8.9,5.3c0-2.3,1.8-4.1,4.1-4.1s4.1,1.8,4.1,4.1S15.3,9.4,13,9.4l0,0c-1.1,0-2.1-0.4-2.9-1.2
                        C9.3,7.5,8.9,6.4,8.9,5.3z"
                    />
                    <path d="M16.9,11.1c-0.2,0-0.3,0-0.5,0.1c-1,0.7-2.2,1.1-3.5,1.1l0,0c-1.3,0-2.5-0.4-3.4-1.1C9.4,11,9.1,11,9,11
                        c-3.6,0.8-6.1,4-6.1,7.7v0.9c0,0.3,0.3,0.6,0.6,0.6l0,0h18.9h0.3v-0.1l0.1-0.1c0.1-0.1,0.2-0.3,0.2-0.4v-0.8
                        C23.1,15,20.6,11.9,16.9,11.1z M9,12.3c1.2,0.8,2.6,1.2,4,1.2s2.8-0.4,4-1.2c2.9,0.8,4.9,3.4,4.9,6.4v0.2H4.1v-0.2
                        C4.1,15.7,6.1,13.1,9,12.3z"
                    />
                </g>
                <path
                  fill="var(--pro-dark-color, #C8A0C7)"
                  d="M4.9,18.1h16.2c2.7,0,4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9H4.9C2.2,27.9,0,25.7,0,23 S2.2,18.1,4.9,18.1z"
                />
                <g>
                    <path
                      fill="#FFFFFF"
                      d="M9.7,22.3c0,1.1-0.8,1.7-2.1,1.7H6.5v1.4H5.6v-4.9h2C8.9,20.6,9.7,21.2,9.7,22.3z M8.8,22.3c0-0.6-0.4-1-1.2-1H6.5v2h1.1C8.4,23.3,8.8,22.9,8.8,22.3z"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M13.7,25.5l-1-1.4c-0.1,0-0.1,0-0.2,0h-1.1v1.4h-0.9v-4.9h2c1.3,0,2.1,0.7,2.1,1.7c0,0.7-0.4,1.3-1,1.6l1.1,1.6H13.7z M12.5,21.3h-1.1v2h1.1c0.8,0,1.2-0.4,1.2-1C13.7,21.7,13.3,21.3,12.5,21.3z"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M15.1,23c0-1.5,1.1-2.5,2.6-2.5s2.6,1.1,2.6,2.5s-1.1,2.5-2.6,2.5C16.3,25.6,15.1,24.5,15.1,23z M19.5,23c0-1-0.7-1.7-1.7-1.7S16.1,22,16.1,23s0.7,1.7,1.7,1.7C18.8,24.8,19.5,24,19.5,23z"
                    />
                </g>
            </svg>
        );
    }

    renderStudentIcon() {
        const { isActive } = this.props;

        return (
            <svg
              block="UserIcon"
              mods={ { isActive, isStudent: true } }
              width="20"
              height="24"
              viewBox="0 0 20 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M13.9,15c-0.2,0-0.3,0-0.4,0.1c-2.1,1.5-4.9,1.5-7,0C6.4,15,6.2,15,6,15c-3.5,0.8-6.1,4-6,7.6l0,0.9c0,0.2,0.1,0.3,0.2,0.4
                    C0.3,24,0.4,24,0.5,24c0,0,0,0,0,0h18.8l0,0l0,0c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.3,0.1-0.4v-0.8C20,19,17.5,15.9,13.9,15z
                     M6,16.2c1.2,0.8,2.5,1.2,4,1.2c1.4,0,2.8-0.4,4-1.2c2.9,0.8,4.9,3.4,4.9,6.4v0.2H1.1v-0.2C1.1,19.6,3.1,17,6,16.2z"
                />
                <path d="M1.5,3.5l3.4,1.2v1.9C4.9,6.8,5,7,5.1,7.1c0.1,0.1,0.3,0.1,0.5,0.1C7,6.6,8.4,6.3,10,6.3c1.5,0,2.9,0.2,4.3,0.8
                    c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3-0.1C14.9,7,15,6.8,15,6.6V4.7L16,4.3v2.6c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-3
                    l1.3-0.5c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2-0.2-0.4-0.4-0.5L10.1,0C10,0,9.9,0,9.8,0L1.6,2.5C1.3,2.6,1.2,2.8,1.2,3
                    C1.2,3.2,1.3,3.4,1.5,3.5z M14,5.9c-1.2-0.4-2.4-0.6-3.6-0.6c-0.1,0-0.3,0-0.4,0c-1.4-0.1-2.7,0.1-4,0.6V4.7C7.2,4.2,8.6,4,10,4.1
                    c1.4,0,2.7,0.2,4,0.6V5.9z M10,1.1l6.6,2l-2.1,0.7C13,3.2,11.5,3,10,3C8.4,3,6.9,3.2,5.4,3.8L3.4,3L10,1.1z"
                />
                <path d="M5.6,7.4C5.3,7.3,5,7.5,5,7.8c-0.2,0.8-0.2,1.6,0,2.4C5.6,12.5,7.7,14,10,14c0.4,0,0.8-0.1,1.3-0.2
                    c2.7-0.7,4.4-3.5,3.7-6.2c-0.1-0.3-0.4-0.4-0.6-0.4c-0.3,0.1-0.4,0.4-0.4,0.6c0.6,2.2-0.8,4.4-2.9,5c-2.2,0.6-4.4-0.8-5-2.9
                    C5.8,9.3,5.8,8.6,6,8C6,7.7,5.9,7.5,5.6,7.4z"
                />
            </svg>
        );
    }

    renderDefaultIcon() {
        const { isActive } = this.props;

        return (
            <svg
              block="UserIcon"
              mods={ { isActive } }
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M10.1,10.6L10.1,10.6c2.9,0,5.3-2.4,5.3-5.3C15.4,2.4,13,0,10.1,0l0,0C8.7,0,7.4,0.6,6.4,1.6S4.8,3.9,4.8,5.3
                    c0,1.4,0.6,2.8,1.6,3.8S8.7,10.6,10.1,10.6z M6.1,5.3c0-2.3,1.8-4.1,4.1-4.1s4.1,1.8,4.1,4.1s-1.8,4.1-4.1,4.1l0,0
                    C9.1,9.3,8.1,8.9,7.3,8.2C6.5,7.4,6.1,6.4,6.1,5.3z"
                />
                <path d="M14,11c-0.2,0-0.3,0-0.5,0.1c-1,0.7-2.2,1.1-3.5,1.1c0,0,0,0-0.1,0c-1.2,0-2.4-0.4-3.4-1.1c-0.1-0.2-0.4-0.2-0.5-0.2
                    c-3.6,0.8-6.1,4-6.1,7.6v0.9C0,19.7,0.3,20,0.6,20l0,0h18.8h0.3v-0.2c0.2-0.1,0.3-0.3,0.3-0.5v-0.8C20.1,14.9,17.6,11.8,14,11z
                     M6.2,12.2c1.2,0.8,2.6,1.2,4,1.2c0,0,0,0,0.1,0c1.4,0,2.7-0.4,3.9-1.2C17,13,19,15.5,19,18.5v0.2H1.3v-0.2
                    C1.3,15.5,3.3,13,6.2,12.2z"
                />
            </svg>
        );
    }

    render() {
        const { isPro, isStudent } = this.props;

        if (isPro) {
            return this.renderProIcon();
        }

        if (isStudent) {
            return this.renderStudentIcon();
        }

        return this.renderDefaultIcon();
    }
}

export default UserIconComponent;
